import React from "react";
import {
  InboxIcon,
  ArrowUpTrayIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import { cn } from "../../../utils/cn";

interface ToolbarButtonsProps {
  user: any;
  isGuest: boolean;
  commentsCount: number;
  isCommentMode: boolean;
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
  onToggleCommentMode: () => void;
  onShare: () => void;
}

export const ToolbarButtons: React.FC<ToolbarButtonsProps> = ({
  user,
  isGuest,
  commentsCount,
  isCommentMode,
  isSidebarOpen,
  onToggleSidebar,
  onToggleCommentMode,
  onShare,
}) => {
  return (
    <div className="flex items-center gap-6">
      {/* Comments Button */}
      <div className="relative group">
        <button
          onClick={onToggleSidebar}
          className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-gray-200 text-gray-700 hover:border-gray-300 transition-colors"
        >
          <InboxIcon className="w-5 h-5" />
          <span className="text-sm font-medium">{commentsCount}</span>
        </button>
        <div
          className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-2 py-1 bg-gray-900 text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap"
          style={{ color: "#ffffff" }}
        >
          View all comments
        </div>
      </div>

      {/* Add Comment Button */}
      <div className="relative group">
        {user || isGuest ? (
          <button
            onClick={onToggleCommentMode}
            className={cn(
              "flex items-center justify-center transition-colors",
              isCommentMode
                ? "text-indigo-600"
                : "text-gray-700 hover:text-indigo-600"
            )}
          >
            <PencilSquareIcon className="w-5 h-5" />
          </button>
        ) : (
          <button
            onClick={onToggleCommentMode}
            className="px-4 py-1.5 bg-black text-sm font-medium rounded-full hover:bg-gray-900 transition-colors"
            style={{ color: "#ffffff" }}
          >
            Sign in to comment
          </button>
        )}
        <div
          className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-2 py-1 bg-gray-900 text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap"
          style={{ color: "#ffffff" }}
        >
          {isCommentMode ? "Exit comment mode" : "Add a comment"}
        </div>
      </div>

      <div className="h-6 w-px bg-gray-200 my-auto" />

      {/* Share Button */}
      {user && (
        <div className="relative group">
          <button
            onClick={onShare}
            className="flex items-center justify-center text-gray-700 hover:text-indigo-600 transition-colors"
          >
            <ArrowUpTrayIcon className="w-5 h-5" />
          </button>
          <div
            className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-2 py-1 bg-gray-900 text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap"
            style={{ color: "#ffffff" }}
          >
            Share project
          </div>
        </div>
      )}

      {/* User Avatar */}
      {user ? (
        <div className="w-8 h-8 rounded-full bg-black flex items-center justify-center">
          <span className="font-medium text-sm" style={{ color: "#ffffff" }}>
            {user.email?.[0].toUpperCase() || "U"}
          </span>
        </div>
      ) : isGuest ? (
        <div className="w-8 h-8 rounded-full bg-black flex items-center justify-center">
          <span className="font-medium text-sm" style={{ color: "#ffffff" }}>
            G
          </span>
        </div>
      ) : null}
    </div>
  );
};
